/** Nombre público; los identificadores de infraestructura conservan su nombre. */
export const NOMBRE_APP = 'Rankealo';
export const LEMA_APP = 'El ranking de tu grupo de pádel.';
